import React from 'react';
import {
  Grid,
  Card,
  CardMedia,
  Box,
  Typography,
  Container,
} from '@mui/material';

// Импортируем картинки
import manicure1 from '../assets/images/portfolio/manicure-1.png';
import lashes1 from '../assets/images/portfolio/lashes-1.jpg';
import hair1 from '../assets/images/portfolio/hair-1.png';
import manicure2 from '../assets/images/portfolio/manicure-2.jpg';
import lashes2 from '../assets/images/portfolio/lashes-2.png';
import hair2 from '../assets/images/portfolio/hair-2.png';

const Portfolio = () => {
  const portfolioImages = [
    {
      id: 1,
      src: manicure1,  // теперь переменная
      title: 'Маникюр премиум',
      category: 'Маникюр',
    },
    {
      id: 2,
      src: lashes1,
      title: 'Наращивание ресниц 2D',
      category: 'Ресницы',
    },
    {
      id: 3,
      src: hair1,
      title: 'Окрашивание и укладка',
      category: 'Волосы',
    },
    {
      id: 4,
      src: manicure2,
      title: 'Дизайн и покрытие',
      category: 'Маникюр',
    },
    {
      id: 5,
      src: lashes2,
      title: 'Ламинирование ресниц',
      category: 'Ресницы',
    },
    {
      id: 6,
      src: hair2,
      title: 'Уход и блеск волос',
      category: 'Волосы',
    },
  ];
  return (
    <Box
      id="portfolio"
      sx={{
        py: { xs: 6, md: 8 },
        background: `
          radial-gradient(circle at 15% 20%, rgba(201,161,74,0.10) 0%, transparent 24%),
          radial-gradient(circle at 85% 80%, rgba(20,36,95,0.08) 0%, transparent 26%),
          linear-gradient(180deg, #f3f3f1 0%, #ecece9 100%)
        `,
      }}
    >
      <Container>
        <Typography
          variant="h3"
          textAlign="center"
          gutterBottom
          sx={{
            color: '#14245f',
            mb: 1.5,
            fontFamily: '"Playfair Display", serif',
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.8rem' },
          }}
        >
          Наши работы
        </Typography>

        <Typography
          textAlign="center"
          sx={{
            maxWidth: 640,
            mx: 'auto',
            mb: 5,
            color: '#667085',
            lineHeight: 1.8,
            fontSize: { xs: 14.5, md: 15.5 },
          }}
        >
          Посмотрите примеры работ наших мастеров: аккуратные формы, чистая
          техника и эстетичный результат.
        </Typography>

        <Grid container spacing={3}>
          {portfolioImages.map((image) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={image.id}>
              <Card
                sx={{
                  position: 'relative',
                  overflow: 'hidden',
                  borderRadius: 4,
                  boxShadow:
                    '0 14px 34px rgba(0,0,0,0.08), 0 6px 16px rgba(20,36,95,0.05)',
                  border: '1px solid rgba(20,36,95,0.06)',
                  backgroundColor: '#fff',
                  '&:hover .portfolio-image': {
                    transform: 'scale(1.06)',
                  },
                }}
              >
                <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                    height="360"
                    image={image.src}
                    alt={image.title}
                    className="portfolio-image"
                    sx={{
                      objectFit: 'cover',
                      transition: 'transform 0.45s ease',
                    }}
                  />

                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      background:
                        'linear-gradient(180deg, rgba(10,12,24,0.04) 0%, rgba(10,12,24,0.52) 100%)',
                    }}
                  />

                  <Box
                    sx={{
                      position: 'absolute',
                      top: 14,
                      left: 14,
                      zIndex: 2,
                      px: 1.4,
                      py: 0.6,
                      borderRadius: 999,
                      background: 'rgba(255,255,255,0.86)',
                      border: '1px solid rgba(201,161,74,0.22)',
                      color: '#14245f',
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    {image.category}
                  </Box>

                  <Box
                    sx={{
                      position: 'absolute',
                      left: 16,
                      right: 16,
                      bottom: 16,
                      zIndex: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: 18,
                        lineHeight: 1.3,
                        textShadow: '0 2px 10px rgba(0,0,0,0.24)',
                      }}
                    >
                      {image.title}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      boxShadow: 'inset 0 0 0 1px rgba(201,161,74,0.14)',
                      pointerEvents: 'none',
                    }}
                  />
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Portfolio;